import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';


@customElement('light-specsheet-page')
export class LightSpecsheetPage extends LitElement {

	static styles = css`
	  :host {
		background-color: #fff;
		color: #000;
		margin-bottom: 20px;
		overflow: hidden;
		position: relative;
		box-sizing: border-box;
		page-break-after: page;
		page-break-before: page;
		border: 1px solid black;
		width: 100%;
		max-height: 267mm;
		min-width: 210mm;
		display: flex;
		flex-direction: column;
	  }

	  @-moz-document url-prefix(){
		 :host {
		 max-height: 257mm;
		}
	}

	  @media print {
		:host {
		  margin-bottom: 0;
		  width: 210mm;
		  height: 297mm;
		  border: none;
		  overflow: hidden;
		}
	  }

	`;

	render() {
		return html`

			<slot></slot>

		`;
	}
}
